import { Observer } from 'mobx-react-lite';
import React from 'react';
import { ContextColor } from '../../constants/color.enum';
import { useContextColorStyle } from '../../hooks/useContextColor.hook';
import BaseIcon from '../BaseIcon/BaseIcon';
var BaseSelectorInlineOption = function (props) {
    var isSelected = props.isSelected, disabled = props.disabled, label = props.label, onClick = props.onClick, option = props.option, value = props.value;
    var color = option.color, icon = option.icon;
    var iconVariant = option.iconVariant || props.iconVariant;
    // const handler = (e: any) => {
    //   if (isSelected) return;
    //   onClick(e)
    // }
    var style = useContextColorStyle(ContextColor.Primary, color);
    return React.createElement(Observer, { children: function () { return (React.createElement("div", { className: [
                'BaseSelectorInlineOption',
                isSelected ? 'selected' : false,
                disabled ? 'disabled' : false
            ].filter(function (i) { return i; }).join(' '), onClick: onClick, style: style, "data-label": label, "data-value": value },
            icon && React.createElement(BaseIcon, { name: icon, variant: iconVariant }),
            React.createElement("span", null, label))); } });
};
export default BaseSelectorInlineOption;
